const loadingMakup = (
    <div className="py-4 text-center">
        <h2>Loading...</h2>
    </div>
)

export default loadingMakup;